import { backgroundOrange, darkOrange, gold, green, orange } from '@/theme/colors'
import styled from 'styled-components'

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

export const SummaryCard = styled.div`
    background: ${backgroundOrange};
    border: 1px solid #f0e0d6;
    border-radius: 12px;
    padding: 1rem 1.125rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
`

export const SummaryAvatars = styled.div`
    display: flex;
    align-items: center;
    gap: 0.375rem;
    flex: 1;
    min-width: 0;
`

export const SummaryAvatar = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: ${orange};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 13px;
    flex-shrink: 0;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

export const SummaryArrow = styled.span`
    color: ${darkOrange};
    font-size: 1.125rem;
    font-weight: 700;
`

export const SummaryName = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: #262626;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`

export const SummaryAmount = styled.span`
    font-size: 1rem;
    font-weight: 700;
    color: ${darkOrange};
    flex-shrink: 0;
`

export const SummaryCurrencyCode = styled.span`
    font-size: 0.75rem;
    color: ${gold};
    margin-left: 0.25rem;
`

export const ConfirmText = styled.p`
    margin: 0;
    font-size: 0.9375rem;
    color: #374151;
    line-height: 1.5;
`

export const CrossUserWarning = styled.div`
    font-size: 0.8125rem;
    color: #92400e;
    background: #fef3c7;
    border: 1px solid #fde68a;
    padding: 0.625rem 0.875rem;
    border-radius: 8px;
    line-height: 1.4;
`

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
    margin-top: 0.5rem;
`

export const Button = styled.button<{ $variant: 'secondary' | 'danger' }>`
    padding: 0.625rem 1.25rem;
    border-radius: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    border: 1px solid transparent;

    background: ${({ $variant }) => ($variant === 'danger' ? '#dc2626' : 'white')};
    color: ${({ $variant }) => ($variant === 'danger' ? 'white' : '#374151')};
    border-color: ${({ $variant }) => ($variant === 'danger' ? '#dc2626' : '#d1d5db')};

    &:hover:not(:disabled) {
        opacity: 0.9;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`

export const NoWrap = styled.span`
    white-space: nowrap;
`

export const KeepGreen = styled.span`
    color: ${green};
`
